
import { StructuredText } from 'vue-datocms'
import { getIcon } from '~/utils/get-icon.js'
import ArrowRightIcon from '~/assets/images/arrow-right-icon.svg?inline'

export default {
  components: {
    StructuredText,
    ArrowRightIcon,
  },

  props: {
    title: {
      type: String,
      required: true,
    },
    items: {
      type: Array,
      required: true,
    },
    button: {
      type: Object,
      default: null,
    },
    ctaText: {
      type: String,
      default: null,
    },
    ctaLink: {
      type: Object,
      default: null,
    },
    background: {
      type: String,
      default: 'dark',
    },
  },

  computed: {
    buttonIcon() {
      return this.getIcon(this.button.icon)
    },

    buttonLink() {
      return this.$getLinkFromDato(this.button.link)
    },
  },

  methods: {
    getIcon(iconName) {
      return getIcon(iconName)
    },
  },
}
